module.exports = __webpack_public_path__ + "static/media/whatsapp.9000ef43.svg";